import API from '../../../../../services/api';

export const API_FACTURAS = {
    getFacturas: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/facturas' + pagination + searcher).then(res => res.data);
    },
    generateFacturaPDF: async (idFactura) => {
        return API.get('/facturas/generate_pdf/' + idFactura).then(res => res.data);
    },
    regenerateFactura: async (factura) => {
        return API.post('/facturas-s3', factura).then(res => res.data);
    },
    exportExcel: async (facturas) => {
        return API.post('/facturas/export', facturas, {responseType: 'blob'}).then(res => res.data);
    },
    compareFacturasAndVentas: async (facturas) => {
        return API.post('/facturas/compare', facturas, {responseType: 'blob'}).then(res => res.data);
    },
    exportReport: async (data) => {
        return API.post('/facturas/report', data, {responseType: 'blob'}).then(res => res.data);
    },
    noGenerated: async () => {
        return API.post('/facturas/no-generated').then(res => res.data);
    },
}